module.exports = __webpack_public_path__ + "static/media/mes4-ev-logo.eadba8d3.png";